<template>
  <v-container
    class="mb-12"
  >
    <v-row
      align="center"
      justify="center"
      class="text-center mb-4"
    >
      <v-col>
        <v-icon x-large>
          mdi-hand-heart
        </v-icon>
        <h2 class="display-2">
          Spenden / Wunschliste
        </h2>
      </v-col>
    </v-row>

    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        md="10"
        sm="10"
      >
        <v-card>
          <v-card-title>
            Dir gefällt der Kegelmanager oder Du möchtest dem Webmaster gerne etwas für seine Arbeit zukommen lassen?
          </v-card-title>
          <v-card-text class="body-1 font-weight-medium">
            Dann kannst Du mir gerne einen Wunsch aus meiner Amazon Wunschliste erfüllen, per Paypal einen kleinen Betrag für die Kaffeekasse spenden oder wenn Du mich auf einer Kegelbahn siehst, gerne ein Kaltgetränk ausgeben. <v-icon>mdi-emoticon-outline</v-icon><br>
            <v-icon>mdi-heart</v-icon>-lichen Dank!
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="5"
      >
        <v-card
          class="text-center"
        >
          <a href="https://www.amazon.de/hz/wishlist/ls/2Q1F6PLQ8Z46I?ref_=wl_share" target="_blank">
            <v-img
              width="250"
              class="mx-auto"
              src="/static/img/amazon.jpg"
              alt="Amazon.de"
            />
          </a>
          <v-card-actions class="pb-8 mt-4">
            <v-btn
              outlined
              large
              color="primary"
              target="_blank"
              href="https://www.amazon.de/hz/wishlist/ls/2Q1F6PLQ8Z46I?ref_=wl_share"
              class="mx-auto"
            >
              Meine Wunschliste
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col
        cols="5"
      >
        <v-card
          class="text-center"
        >
          <a href="https://paypal.me/nicogrundmann11?locale.x=de_DE" target="_blank">
            <v-img
              width="250"
              class="mx-auto"
              src="/static/img/paypal.jpg"
            />
          </a>
          <v-card-actions class="pb-8 mt-4">
            <v-btn
              outlined
              large
              color="primary"
              target="_blank"
              href="https://paypal.me/nicogrundmann11?locale.x=de_DE"
              class="mx-auto"
            >
              PayPal.me Spende
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Spenden',
  metaInfo: {
    title: 'Wunschliste / Spenden'
  }
}
</script>
